import { Children } from 'react';
import { getElementName } from '../../../utils';
import { SIDE_SHEET_HEADER_CLASS_PREFIX } from '../SideSheetHeader';
import { SIDE_SHEET_BODY_CLASS_PREFIX } from '../SideSheetBody';
import { SIDE_SHEET_FOOTER_CLASS_PREFIX } from '../SideSheetFooter';

var extractContentSections = function extractContentSections(children) {
  var sections = {
    header: null,
    body: null,
    footer: null
  };

  if (!children) {
    return sections;
  }

  Children.forEach(children, function (child) {
    var childName = getElementName(child);

    if (childName === SIDE_SHEET_HEADER_CLASS_PREFIX) {
      sections.header = child;
    }

    if (childName === SIDE_SHEET_BODY_CLASS_PREFIX) {
      sections.body = child;
    }

    if (childName === SIDE_SHEET_FOOTER_CLASS_PREFIX) {
      sections.footer = child;
    }
  });
  return sections;
};

export default extractContentSections;